import { createFileRoute } from '@tanstack/react-router'
import { ConfirmUserPage } from '../../components/pages/Auth/ConfirmUserPage'

type ConfirmSearchParams = {
  email?: string
}

export const Route = createFileRoute('/_auth_not_required/confirm')({
  validateSearch: (search: Record<string, unknown>): ConfirmSearchParams => {
    return {
      email: typeof search.email === 'string' ? search.email : undefined,
    }
  },
  component: ConfirmUserPage,
})
